import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import React, {useImperativeHandle} from 'react'

function ModalTip(props: any, ref: any) {
  const {isOpen, onOpen, onClose} = useDisclosure()

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
      onClose,
    }),
    [],
  )
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay sx={{backdropFilter: 'blur(5px)'}} />
      <ModalContent
        borderRadius={'32px'}
        bgColor={'#F3F9FF'}
        width={'573px'}
        paddingBottom={'24px'}
        paddingTop={'28px'}>
        <ModalHeader
          paddingBottom={'0px'}
          marginBottom={'0px'}
          color={'#01ACFF'}
          fontSize={'12px'}
          fontWeight={500}
          textAlign={'center'}>
          MẸO HAY CHO BẠN
        </ModalHeader>
        <ModalCloseButton top={'26px'} />
        <ModalBody paddingTop={'0px'}>
          <Text
            marginBottom={'5px'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={'24px'}
            color={'#000000'}>
            Bạn có thể chọn cụm từ để dịch nghĩa và kiểm tra phát âm
          </Text>
          <Image src={require('@assets/images/img_tip.png')} />
          {/*<Lorem count={2} />*/}
        </ModalBody>

        <ModalFooter justifyContent="center" alignItems={'center'}>
          <Button
            borderRadius={'12px'}
            alignSelf={'center'}
            backgroundColor="#1890FF"
            mr={3}
            onClick={onClose}>
            <Text color={'#ffffff'} fontWeight={700} fontSize={'16px'}>
              Tôi đã hiểu
            </Text>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default React.forwardRef(ModalTip)
